export const NAME = 'adblocker';

export const ADBLOCKER_DETECTED = 'ADBLOCKER_DETECTED';
export const COOKIES_ENABLED = 'COOKIES_ENABLED';



// WEBPACK FOOTER //
// ./src/services/adblocker/constants.js